import type { Flight } from '../types';
import { toDateStr } from './dates';

export const ACTIVE_ROSTER_THRESHOLD = 2;

/** A month is in the past if it's before the current month */
export function isMonthInPast(month: number, year: number): boolean {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  return year < currentYear || (year === currentYear && month < currentMonth);
}

/**
 * A user's roster is "active" for a given month if they have >= ACTIVE_ROSTER_THRESHOLD
 * flights in that month from today forward. Past flights don't count.
 */
export function hasActiveRoster(
  flights: Flight[],
  month: number,
  year: number,
): boolean {
  const today = toDateStr(new Date());
  let count = 0;
  for (const f of flights) {
    if (f.date < today) continue;
    const d = new Date(f.date + 'T00:00:00');
    if (d.getFullYear() === year && d.getMonth() + 1 === month) {
      count++;
      if (count >= ACTIVE_ROSTER_THRESHOLD) return true;
    }
  }
  return false;
}
